<template>
    <el-dialog :visible.sync="dialogVisible" width="780px">
        <div slot="title" class="column-config_title">
            {{$translate('component.E202007310002', { defaultText: '列配置' })}}<small>{{$translate('component.E202006240001', { defaultText: '请选择要显示的列(可拖拽排序)' })}}</small>
        </div>
        <div class="component-container">
            <div class="clearfix">
                <div class="all-column selected" :draggable="!isOrderFiled" v-for="(item, index) in selectedColumns"
                    :key="'selected' + index">
                        <el-button :draggable="!isOrderFiled"
                            size="mini"
                            :title="$translate(item.label)"
                            @dragstart.native="handleItemDragStart($event, item, index)"
                            @dragend.native="handleItemDragEnd($event)"
                            @dragenter.native="handleItemDragEnter($event, item, index)">
                            {{$translate(item.label)}}
                        </el-button>
                        <em class="btn-icon el-icon-error" v-if="!item.columnStick && !item.hiddenColumn" @click="handleSelectedClose(item, index)"></em>
                        <em @click="handleSelectClick(item)" v-if="isOrderFiled && item.hiddenColumn" class="btn-icon el-icon-circle-plus"></em>
                </div>
                <div class="all-column" v-for="(item, index) in closedColumns" :key="'columns' + index">
                    <el-button size="mini" @click="handleSelectClick(item)" :title="$translate(item.label)">
                        {{$translate(item.label)}}
                    </el-button>
                    <em @click="handleSelectClick(item)" class="btn-icon el-icon-circle-plus"></em>
                </div>
            </div>
            <div class="config-footer">
                <el-row>
                    <el-col :span="12">
                        <el-button size="mini" class="pull-left" @click="handleSelectAll">{{$translate('component.E202006190062', { defaultText: '全选' })}}</el-button>
                        <el-button size="mini" class="pull-left" @click="handleReset">{{$translate('component.E202007310003', { defaultText: '重置' })}}</el-button>
                    </el-col>
                    <el-col :span="12">
                        <el-button size="mini" type="text" @click="handleCancel">{{$translate('component.E202006152345', { defaultText: '取消' })}}</el-button>
                        <el-button size="mini" type="primary" @click="handleSave">{{$translate('component.E202006152363', { defaultText: '确定' })}}</el-button>
                    </el-col>
                </el-row>
            </div>
        </div>
    </el-dialog>
</template>
<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { fieldConfig, getDictDataApi } from '../api';
import { I18nMixins } from '@/components/mixins/i18n';
import utils from '@/components/utils/common';

let columnConfigSwitchCache = null;
/**
 * @module lots/columnConfig
 * @desc 列配置组件
 * @vue-prop {String} pageID - 引入该组件的页面的唯一标识符
 * @vue-prop {Array.<Object>} initColumns - 默认的列配置
 * @vue-data {Boolean} dialogVisible - 组件弹窗显示控制符
 * @vue-data {Array} newOptions - 对传入的下拉框选项进行处理后重新赋值
 * @vue-data {Array.<Object>} columns - 列配置对象
 * @vue-data {Array.<Object>} selectedColumns - 选中的列配置项数组
 * @vue-data {Array.<Object>} closedColumns - 未选中的列配置项数组
 * @vue-data {Object} dragEl - 拖拽的元素
 * @vue-data {Object} dragElData - 拖拽的元素数据
 * @vue-data {String} resourceCode - 引入该组件的页面的resourceCode
 * @vue-event {Array.<Object>} header-change - 返回配置好的列数据
 */
export default {
    mixins: [I18nMixins],
    computed: {
        ...mapGetters(['menus'])
    },
    data() {
        return {
            dialogVisible: false,
            columns: [],
            selectedColumns: null,
            closedColumns: null,
            dragEl: null,
            dragElData: null,
            resourceCode: ''
        };
    },
    props: {
        pageID: String,
        initColumns: {
            type: Array,
            default() {
                return [];
            }
        },
        isOrderFiled: { // 是否排序
            type: Boolean,
            default() {
                return false;
            }
        }
    },
    methods: {
        show(status = true) {
            const _initColumns = _.cloneDeep(this.initColumns);
            this.columns = _initColumns.filter(it => it);
            this.backupColumns = _initColumns.filter(it => it);
            this.dialogVisible = status;
        },
        // 刷新页面数据
        refresh() {
            this.columns = [...this.columns];
        },
        handleSubmenu(childrens) {
            for (let i = 0; i < childrens.length; i++) {
                if (childrens[i].frontUrl === this.$route.path) {
                    this.resourceCode = childrens[i].resourceCode;
                } else {
                    this.deepMenu(childrens[i]);
                }
            }
        },
        deepMenu(node) {
            const nodes = [];
            if (node) {
                nodes.push(node);
                const childrens = node.subResources;
                if (childrens) {
                    this.handleSubmenu(childrens);
                }
            }
        },
        // 添加显示列
        handleSelectClick(item) {
            item.hiddenColumn = false;
            this.refresh();
        },
        // 取消显示列
        handleSelectedClose(item, index) {
            item.hiddenColumn = true;
            this.refresh();
        },
        // 拖拽钩子
        handleItemDragStart(ev, item, key) {
            this.dragElData = { item, key };
            this.dragEl = ev.target;
            this.dragEl.classList.add('draging');
        },
        handleItemDragEnd(ev) {
            if (ev.preventDefault) {
                ev.preventDefault();
            }
            this.dragEl.classList.remove('draging');
            this.dragEl = null;
            this.dragElData = null;
        },
        handleItemDragEnter(ev, item, key) {
            if (item.prop !== this.dragElData.item.prop) {
                this.selectedColumns.splice(this.dragElData.key, 1);
                this.selectedColumns.splice(key, 0, this.dragElData.item);
                this.dragElData.key = key;
            }
        },
        // 全选
        handleSelectAll() {
            if (this.isOrderFiled) {
                this.selectedColumns.forEach(element => {
                    element.hiddenColumn = false;
                });
            } else {
                this.closedColumns.forEach(element => {
                    element.hiddenColumn = false;
                });
            }

            this.refresh();
        },
        handleReset() {
            if (this.isOrderFiled) {
                this.columns = _.cloneDeep(this.initColumns);
            } else {
                this.columns = _.cloneDeep(this.backupColumns);
            }
        },
        handleCancel() {
            this.show(false);
        },
        // 确定，返回操作之后的表头列表
        handleSave() {
            let _columns = this.selectedColumns.concat(this.closedColumns);
            let _selectedColumns = _.cloneDeep(this.selectedColumns);
            if (this.isOrderFiled) {
                _columns = this.selectedColumns;
                _selectedColumns = _selectedColumns.filter(it => !it.hiddenColumn);
            }
            this.$emit('header-change', _columns);
            this.show(false);

            if (!this.pageID) return;
            let allColumns = [];
            let allColumnsprop = [];

            for (const item of _selectedColumns) {
                allColumns.push(item.label);
                allColumnsprop.push(item.prop);
            }
            allColumns = allColumns.join(',');
            allColumnsprop = allColumnsprop.join(',');
            const params = {
                'configName': allColumnsprop,
                'configNameCn': allColumns,
                'subjectType': this.pageID,
                'moduleCode': this.resourceCode,
                'updateTime': utils.formatDateTime(new Date().getTime())
            };
            fieldConfig.set(params).then(() => {});
        }
    },
    watch: {
        columns(val) {
            if (!this.isOrderFiled) {
                this.selectedColumns = this.columns.filter(item => !item.hiddenColumn);
                this.closedColumns = this.columns.filter(item => item.hiddenColumn);
            } else {
                this.selectedColumns = this.columns;
            }
        }
    },
    /** 初始化钩子 */
    // eslint-disable-next-line max-lines-per-function, complexity
    async created() {
        if (!this.pageID) return;
        const menu = { subResources: _.cloneDeep(this.menus) };
        await this.deepMenu(menu);
        const columns = _.cloneDeep(this.initColumns);
        let isNewLogic = false;
        /**
         * 字典控制新增列展示逻辑
         * 1. 通过 getDictDataApi 获取字典配置 LCRM_COLUMN_CONFIG_SWITCH
         * 2. 字典值为 'ON' 时启用新逻辑，为其他值时使用旧逻辑
         * 3. columnConfigSwitchCache 用于缓存字典值，避免重复请求
         */
        try {
            if (columnConfigSwitchCache === null) {
                const switchRes = await getDictDataApi({ dictCodes: 'LCRM_COLUMN_CONFIG_SWITCH' });
                columnConfigSwitchCache = switchRes?.data?.LCRM_COLUMN_CONFIG_SWITCH?.SWITCH === 'ON';
            }
            isNewLogic = columnConfigSwitchCache;
        } catch (e) {
            // console.warn('获取列配置开关失败，使用旧逻辑', e);
        }
        const params = {
            'moduleCode': this.resourceCode,
            'subjectType': this.pageID
        };
        const res = await fieldConfig.get(params);
        if (res && res.data && res.data.configName) {
            /**
             * columnAddTime 字段新增时间
             * 判断如下
             * 当配置存在columnAddTime 时
             * columnAddTime>接口返回的更新时间,即属于新增,默认展示
             * columnAddTime<接口返回的更新时间,即用户已经在当前列配置弹窗操作过了,按接口返回的字段处理,接口存在该字段即展示
             *
            */
            const selectedColumns = [];
            const configName = res.data.configName || '';
            const hasUpdateTime = !!res.data.updateTime;
            const configUpdateTime = res.data.updateTime ? new Date(res.data.updateTime).getTime() : 0;
            const SEEN_COLUMNS_KEY = `seenColumns_${this.pageID}_${this.resourceCode}`;
            let seenColumns = new Set();
            try {
                seenColumns = new Set(JSON.parse(sessionStorage.getItem(SEEN_COLUMNS_KEY) || '[]'));
            } catch (e) {
                sessionStorage.removeItem(SEEN_COLUMNS_KEY);
            }
            if (isNewLogic) {
                seenColumns = new Set();
            }
            if (_.isString(configName)) {
                columns.forEach(item => { item.hiddenColumn = true; });
                const savedProps = new Set(configName.split(','));
                // eslint-disable-next-line complexity
                columns.forEach(c => {
                    if (isNewLogic) {
                        /**
                         * 新增列判断逻辑（基于字典开关控制）
                         * 1. columnAddTime: 列字段的创建时间戳（毫秒）
                         * 2. columnAddTimeTs: 转换为时间戳格式，非法值视为0
                         * 3. isValidColumnAddTime: 判断columnAddTime是否为有效时间（大于0）
                         * 4. isAfterUpdateTime: 判断列创建时间是否晚于配置更新时间
                         * 5. isSeen: 判断用户是否已看过该新增列（从sessionStorage缓存中读取）
                         * 判断规则：
                         *   - 无更新时间：只要列有有效的columnAddTime且用户未看过，即为新增列
                         *   - 有更新时间：列的columnAddTime晚于配置更新时间且用户未看过，才为新增列
                         */
                        const columnAddTime = c.columnAddTime;
                        const columnAddTimeTs = typeof columnAddTime === 'number' && columnAddTime > 0 ? columnAddTime : 0;
                        const isValidColumnAddTime = columnAddTimeTs > 0;
                        const isAfterUpdateTime = isValidColumnAddTime && columnAddTimeTs > configUpdateTime;
                        const isSeen = seenColumns.has(c.prop);
                        if (!hasUpdateTime) {
                            c.isNewColumn = !savedProps.has(c.prop) && isValidColumnAddTime && !isSeen;
                        } else {
                            c.isNewColumn = !savedProps.has(c.prop) && isAfterUpdateTime && !isSeen;
                        }
                    }
                });
                const newSeenColumns = columns.filter(c => c.isNewColumn).map(c => c.prop);
                /**
                 * 新增列缓存管理
                 * 1. 记录用户已看过的新增列到sessionStorage
                 * 2. 下次打开弹窗时，已看过的列不再标记为新增列（避免重复提示）
                 * 3. 缓存key格式: seenColumns_{pageID}_{resourceCode}
                 */
                if (isNewLogic && newSeenColumns.length > 0) {
                    newSeenColumns.forEach(prop => seenColumns.add(prop));
                    sessionStorage.setItem(SEEN_COLUMNS_KEY, JSON.stringify([...seenColumns]));
                }
                if (this.isOrderFiled) {
                    const configNameList = configName.split(',');
                    columns.forEach(c => {
                        const columnIndex = configNameList.findIndex(p => p === c.prop);
                        if (columnIndex !== -1) {
                            c.hiddenColumn = false;
                        }
                    });
                    // eslint-disable-next-line max-depth
                    if (isNewLogic) {
                        /**
                         * 排序模式下新增列的处理
                         * 直接将isNewColumn为true的列设为可见，无需手动勾选
                         */
                        columns.forEach(c => {
                            if (c.isNewColumn) {
                                c.hiddenColumn = false;
                            }
                        });
                    }
                } else {
                    configName.split(',').forEach(prop => {
                        const columnIndex = columns.findIndex(c => c.prop === prop);
                        if (columnIndex !== -1) {
                            columns[columnIndex].hiddenColumn = false;
                            selectedColumns.push(columns[columnIndex]);
                            columns.splice(columnIndex, 1);
                        }
                    });
                    // eslint-disable-next-line max-depth
                    if (isNewLogic) {
                        /**
                         * 新增列自动展示到选中列
                         * 1. 使用addedProps记录已添加到selectedColumns的列prop
                         * 2. 遍历columns，将isNewColumn为true且不在已选中的列自动添加到selectedColumns
                         * 3. 自动展示新增列，无需用户手动勾选
                         */
                        const addedProps = new Set(selectedColumns.map(c => c.prop));
                        columns.forEach(c => {
                            if (c.isNewColumn && !addedProps.has(c.prop)) {
                                c.hiddenColumn = false;
                                selectedColumns.push(c);
                                addedProps.add(c.prop);
                            }
                        });
                    }
                }
            }
            /**
             * 列数据去重处理
             * 1. allProps 用于记录已处理的列prop，避免重复
             * 2. uniqueSelectedColumns 去重后的选中列
             * 3. uniqueColumns 去重后的未选中列
             * 4. 最终输出：选中列在前 + 未选中列在后
             */
            const allProps = new Set();
            const uniqueSelectedColumns = [];
            selectedColumns.forEach(c => {
                if (!allProps.has(c.prop)) {
                    uniqueSelectedColumns.push(c);
                    allProps.add(c.prop);
                }
            });
            const uniqueColumns = [];
            columns.forEach(c => {
                if (!allProps.has(c.prop)) {
                    uniqueColumns.push(c);
                    allProps.add(c.prop);
                }
            });
            this.$emit('header-change', uniqueSelectedColumns.concat(uniqueColumns));
        } else {
            /**
             * 无历史配置时（首次进入）
             * 1. 所有列默认显示
             * 2. 新逻辑模式下：所有列标记为新增列
             */
            columns.forEach(item => {
                item.hiddenColumn = false;
                if (isNewLogic) {
                    item.isNewColumn = true;
                }
            });
            this.$emit('header-change', columns);
        }
    }
};

</script>

<style lang="less">
.column-config_title{
    font-size: 18px;
    small{
        margin-left: 25px;
    }
}
.component-container {
    padding: 0 8px 8px;
    .all-column {
        float: left;
        cursor: pointer;
        margin: 0 10px 10px 0;
        position: relative;

        button {
            width: 138px;

            span {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                display: block;
            }
        }

        .el-button {
            background: #f2f2f2;
        }

        &.disabled {
            display: none;
        }

        .btn-icon {
            position: absolute;
            right: -6px;
            top: -6px;
            color: #409EFF;
        }

        .el-icon-circle-check {
            color: #C3C7C7;
            display: none;
        }

        .el-icon-circle-check:hover {
            cursor: not-allowed;
        }

        .el-icon-error {
            color: #FF3300;
        }

        &.selected {
            .el-button,
            .el-button.is-disabled,
            .el-button.is-disabled:hover,
            .el-button.is-disabled:focus {
                color: #555757;
                border-color: #CECECE;
            }

            .el-button {
                background: #fff;
            }
        }

    }

    .config-footer {
        text-align: right;
        margin-top: 18px;
    }

    .box-card {
        margin-top: 20px;
    }

    .pull-left {
        float: left;
    }

    .clearfix:after {
        height: 0;
        content: '';
        display: block;
        visibility: hidden;
        clear: both;
    }
}

</style>
